const Payment = () => import('./Payment.vue')

const ExpenseList = () => import('./pages/ExpenseList.vue')
const ExpenseEdit = () => import('./pages/ExpenseEdit.vue')
const RevenueList = () => import('./pages/RevenueList.vue')
const RevenueEdit = () => import('./pages/RevenueEdit.vue')

const routes = {
  component: Payment,
  path: '/pagamentos',
  meta: {
    label: 'Financeiro'
  },
  children: [
    {
      path: 'despesas',
      component: ExpenseList,
      name: 'paymentsExpenseList',
      meta: {
        component: 'Despesas',
        label: 'Contas a Pagar',
        requiredPermission: {resource: 'payment', value: 'view'}
      }
    },
    {
      path: 'despesa/:id',
      component: ExpenseEdit,
      name: 'paymentExpenseEdit',
      meta: {
        component: 'Despesas',
        hidden: true,
        label: 'Atualizar',
        requiredPermission: {resource: 'payment', value: 'manage'}
      }
    },
    {
      path: 'faturamentos',
      component: RevenueList,
      name: 'paymentsRevenueList',
      meta: {
        component: 'Faturamentos',
        label: 'Contas a Receber',
        requiredPermission: {resource: 'payment', value: 'view'}
      }
    },
    {
      path: 'faturamento/:id',
      component: RevenueEdit,
      name: 'paymentRevenueEdit',
      meta: {
        component: 'Faturamentos',
        hidden: true,
        label: 'Atualizar',
        requiredPermission: {resource: 'payment', value: 'manage'}
      }
    }
  ]
}

export default routes



// WEBPACK FOOTER //
// ./src/pages/payment/routes.js